import { redirect } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { meProfileQueryOptions } from "./me-profile";

// beforeLoad guard for admin-only routes. Redirects non-admins to their profile.
export async function requireAdminRoute({ context }: { context: { queryClient: QueryClient } }) {
  const me = await context.queryClient.ensureQueryData(meProfileQueryOptions);
  // eslint-disable-next-line @typescript-eslint/only-throw-error
  if (me.role !== "admin") throw redirect({ to: "/settings/me" });
}
